/** Beverly Hills Rev2 experiment control totals (audit references). */
export const BH_EXPERIMENT_GEOID = '0606308';

export const ELEC_CAP_RES_2015 = 200_714_500;
export const ELEC_CAP_COM_2015 = 367_176_420;
export const ELEC_CAP_IND_2015 = 673_731;
export const ELEC_CAP_NONRES_2015 = ELEC_CAP_COM_2015 + ELEC_CAP_IND_2015;
export const ELEC_CAP_TOTAL_2015 = ELEC_CAP_RES_2015 + ELEC_CAP_NONRES_2015;

export const ELEC_CAP_TOTAL_2019 = 510_985_589;
export const ELEC_CAP_RES_2019 = 164_963_933;
export const ELEC_CAP_NONRES_2019 = 346_021_656;

export const GAS_CAP_TOTAL_2015 = 14_808_582.7216262;
export const GAS_CAP_TOTAL_2019 = 16_762_845.849802371;
export const GAS_CAP_TOTAL_2015_DISPLAY = 14_808_583;
export const GAS_CAP_TOTAL_2019_DISPLAY = 16_762_846;

export const GAS_RES_MODEL_2015 = 10_869_054.590245418;
export const GAS_RES_MODEL_2019 = 11_364_016.067343064;

/** Commercial-category residual at CAP anchors (res + com = CAP total). */
export const GAS_COM_CAP_2015 = GAS_CAP_TOTAL_2015 - GAS_RES_MODEL_2015;
export const GAS_COM_CAP_2019 = GAS_CAP_TOTAL_2019 - GAS_RES_MODEL_2019;

/** @deprecated Legacy decomposition — use GAS_COM_CAP_* for Rev2 res+com experiment. */
export const GAS_NONRES_COMPLETE_2015 = GAS_COM_CAP_2015;
export const GAS_NONRES_COMPLETE_2019 = GAS_COM_CAP_2019;

/** @deprecated Use GAS_NONRES_COMPLETE_* — same numeric value (complete nonresidential at CAP anchors). */
export const GAS_NONRES_RESIDUAL_2015 = GAS_NONRES_COMPLETE_2015;
export const GAS_NONRES_RESIDUAL_2019 = GAS_NONRES_COMPLETE_2019;

export const GAS_COM_MODEL_2015 = 3_482_654.508854696;
export const GAS_COM_MODEL_2019 = 3_603_755.5313913994;

export const GAS_ADDITIONAL_2015 = GAS_NONRES_COMPLETE_2015 - GAS_COM_MODEL_2015;
export const GAS_ADDITIONAL_2019 = GAS_NONRES_COMPLETE_2019 - GAS_COM_MODEL_2019;

export const GAS_PROP_NONRES_2015 = 3_593_522;
export const GAS_PROP_NONRES_2019 = 4_035_952;

export const ELEC_EMISSION_FACTOR_MT_PER_KWH = 0.00024;
export const GAS_EMISSION_FACTOR_MT_PER_THERM = 0.005313;

export const SCE_ELEC_2023_COMMERCIAL = 213_524_034.846624;
export const SCE_ELEC_2023_INDUSTRIAL = 82_278_347.1182167;
export const SCE_ELEC_2023_NONRES =
  SCE_ELEC_2023_COMMERCIAL + SCE_ELEC_2023_INDUSTRIAL;
